import { render } from "./KpDialog.vue?vue&type=template&id=59ba6083&scoped=true"
import script from "./KpDialog.vue?vue&type=script&lang=js"
export * from "./KpDialog.vue?vue&type=script&lang=js"

import "./KpDialog.vue?vue&type=style&index=0&id=59ba6083&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ba6083"]])

export default __exports__